(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dk-rear-shocks"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', () => {

  const cards = document.querySelectorAll('.dk-shock-card');

  const observer = new IntersectionObserver((entries) => {

    entries.forEach(entry => {

      if(entry.isIntersecting){

        entry.target.classList.add('show');

      }

    });

  },{
    threshold:.15
  });

  cards.forEach(card=>observer.observe(card));

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["policy-tabbing"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', function () {

  const sections = document.querySelectorAll('.dk-policy-tabs-section');

  sections.forEach(function (section) {

    const tabs = section.querySelectorAll('.dk-policy-tab');
    const panels = section.querySelectorAll('.dk-policy-panel');

    tabs.forEach(function (tab) {

      tab.addEventListener('click', function () {

        const targetId = this.getAttribute('data-policy-tab');

        /* Remove active state */
        tabs.forEach(function (item) {
          item.classList.remove('active');
        });

        panels.forEach(function (panel) {
          panel.classList.remove('active');
        });

        /* Activate clicked tab */
        this.classList.add('active');

        const targetPanel = section.querySelector('#' + targetId);

        if (targetPanel) {
          targetPanel.classList.add('active');
        }

      });

    });

  });

});


  } catch(e) { console.error(e); }
})();
})();
